module.exports = __webpack_public_path__ + "static/img/logoredpie.995d7bdf.svg";